import React from 'react';
import { MetricsElement } from "react-metrics";

import BlogEmailForm from '../../blog-email-form';

import './subscribe-btn.less';


class SubscribeButton extends React.Component{
  
  constructor(){
    super();
    this.state = {
      modalOpen: false
    }
  }

  static metricsAttributes = {
    'modal': () => ({ element: 'div' }),
    'anchor': (props) => {
      let {href} = props || {};
      let metricsProps = { 
        element: 'a'
      };
      if(href){
        metricsProps.href = href;
        metricsProps.target="_blank";
      }
      return metricsProps;
    }
  }

   getButtonAttributes = (type) => {
    if(type === 'modal'){
      return { onClick: () => this.setState({modalOpen: true}) };
    }
    return {};
  }

  render(){
    let {metricsElementType, linkId, match: {url} = {}} = this.props;
    let {modalOpen} = this.state;
    let metricsAttributes = SubscribeButton.metricsAttributes[metricsElementType || 'anchor'];
    metricsAttributes = metricsAttributes 
                        ? metricsAttributes(this.props)
                        : {};

    let buttonAttributes = this.getButtonAttributes(metricsElementType);

    return (
      <React.Fragment>
        <MetricsElement
          {...metricsAttributes}
          data-metrics-event-name="linkClick"
          data-metrics-event="e_linkClick"
          data-metrics-link-id={linkId}
        >
          <div className="subscribe-btn" {...buttonAttributes} >Subscribe</div>
        </MetricsElement>
        {
          metricsElementType === 'modal' && modalOpen &&
          <BlogEmailForm key={url} isOpen={modalOpen} handleClose={() => this.setState({ modalOpen: false }) }/>
        }
      </React.Fragment>
    );
  }
  
}

export default SubscribeButton;
